import React from "react";
import CallToActionBtn from "components/Reusables/CallToActionBtn";
import { colors } from "utils/styles";

export default function RenewMembership() {
	return (
		<CallToActionBtn
			variant="red"
			text="Renew Membership"
			icon="membership"
			iconColor={colors.white}
			iconStyle={{ marginRight: "0.5em" }}
			link={`${process.env.APP_URL}/membership`}
		/>
	);
}
